import { Api } from '../helpers';

const orderModel = {
  getOrderBasicInfo(params) {
    const queryParams = params;
    const path = 'order/get_basic_info';
    return Api.get({ path, queryParams });
  },

  getTransactionsDetails(params) {
    const queryParams = params;
    const path = 'order/get_transactions_v2';
    return Api.get({ path, queryParams });
  },

  addManualTag(url, data) {
    const body = data;
    const path = `order/${url}`;
    return Api.post({ path }, { body });
  },

  getRefundRef(data) {
    const body = data;
    const path = `order/get_refund_ref`;
    return Api.post({ path }, { body });
  },

  getCrystalDetails(params) {
    const queryParams = params;
    const path = 'order/view_crystal';
    return Api.get({ path, queryParams });
  },

  getDominosDetails(params, url) {
    const queryParams = params;
    const path = `order/${url}`;
    return Api.get({ path, queryParams });
  },

  getInstructions(params, url) {
    const queryParams = params;
    const path = `mx_instructions/get_mx_instructions`;
    return Api.get({ path, queryParams });
  },

  getOrdersFromCartId(cartId) {
    const queryParams = {
      cart_id: cartId,
    };
    const path = `cart/get_orders`;
    return Api.get({ path, queryParams });
  },

  getRefundDeatilsOnCart(queryParams) {
    const path = `cart/get_refunds`;
    return Api.get({ path, queryParams });
  },

  getEmergencyDrops(queryParams){
    const path = 'order/get_emergency_drops';
    return Api.get({ path, queryParams });
  }
};

export default orderModel;
